import { createApi } from '@reduxjs/toolkit/query/react';
import { getImageFormData } from 'common/utils';
import { axiosBaseQuery, getApiBaseUrl } from 'modules/api/utils';

import { Attachment } from './types';

import type { ImageFile } from 'common/components/ImageDropzoneWithPreview/types';

export const attachmentsApi = createApi({
  reducerPath: 'attachmentsApi',
  baseQuery: axiosBaseQuery({ baseURL: getApiBaseUrl('v1') }),
  endpoints: (builder) => ({
    uploadAttachment: builder.mutation<Attachment, ImageFile>({
      query: (payload) => ({
        url: '/attachments',
        method: 'POST',
        data: getImageFormData(payload, 'file'),
      }),
    }),
    deleteAttachment: builder.mutation<void, Pick<Attachment, 'id'>>({
      query: ({ id }) => ({
        url: `/attachments/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const { useDeleteAttachmentMutation } = attachmentsApi;
